if (!customElements.get('mega-menu-pxg')) {
  customElements.define(
    'mega-menu-pxg',
    class MegaMenuPxg extends HTMLElement {
      constructor() {
        super();
        this.secondaryNavHeight = 0;
        this.secondaryNavElement = null;
        this.setNavHeight();
        // Setup mega menus
        document.querySelectorAll('[data-megamenu-trigger]').forEach((trigger) => this.setupMegaMenu(trigger));
        window.addEventListener('resize', this.setNavHeight.bind(this));
        // Need to check if the secondary nav is present on the page, if true then we need to calculate the offset of the secondary nav
        // and add it to the header height.
        window.elementReady('.secondary-nav-pxg', false, this.secondaryNavCheck.bind(this))
              .then(this.secondaryNavCheck.bind(this));
      }

      setNavHeight() {
        const totalHeight = Array.from(document.querySelectorAll('.js-header-height-calculation')).reduce(
          (total, nav) => total + nav.getBoundingClientRect().height,
          0
        );
        const clamp = (num, min, max) => Math.min(Math.max(num, min), max);
        this.secondaryNavHeight = Math.floor(this?.secondaryNavElement?.getBoundingClientRect()?.height) || 0;
        // This offset is used strictly for secondary nav
        document.documentElement.style.setProperty('--secondary-nav-offset', `${totalHeight}px`);
        document.documentElement.style.setProperty('--nav-height', `${clamp(totalHeight + this.secondaryNavHeight, 1, 180)}px`);
      }

      setupMegaMenu(trigger) {
        const megaMenu = document.getElementById(trigger.getAttribute('aria-controls'));
        const menuLinks = megaMenu.querySelectorAll('a');
        let isOpen = false;
        // Track all mega menus and triggers
        const allMegaMenus = document.querySelectorAll('[data-megamenu-trigger]');
        const closeAllMenusExcept = (exceptMenu) => {
          allMegaMenus.forEach((otherTrigger) => {
            if (otherTrigger !== trigger) {
              const otherMenu = document.getElementById(otherTrigger.getAttribute('aria-controls'));
              otherTrigger.setAttribute('aria-expanded', 'false');
              otherMenu.setAttribute('aria-hidden', 'true');
              otherMenu.classList.add('invisible', 'opacity-0');
              otherMenu.querySelectorAll('a').forEach((link) => link.setAttribute('tabindex', '-1'));
            }
          });
        };
        const toggleMenu = (open) => {
          if (open) {
            closeAllMenusExcept(megaMenu);
          }
          isOpen = open;
          trigger.setAttribute('aria-expanded', open);
          megaMenu.setAttribute('aria-hidden', !open);
          megaMenu.classList.toggle('invisible', !open);
          megaMenu.classList.toggle('opacity-0', !open);
          menuLinks.forEach((link) => link.setAttribute('tabindex', open ? '0' : '-1'));
        };
        const handleTriggerKeydown = (e) => {
          if (e.key === 'Tab' && !e.shiftKey && !isOpen) {
            e.preventDefault();
            toggleMenu(true);
            menuLinks[0]?.focus();
          } else if (e.key === 'Escape' && isOpen) {
            e.preventDefault();
            toggleMenu(false);
            trigger.focus();
          }
        };
        const handleMenuLinkKeydown = (e, index) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            toggleMenu(false);
            trigger.focus();
          } else if (e.key === 'Tab') {
            if (!e.shiftKey && index === menuLinks.length - 1) {
              toggleMenu(false);
            } else if (e.shiftKey && index === 0) {
              e.preventDefault();
              toggleMenu(false);
              trigger.focus();
            }
          }
        };
        // Mouse events
        trigger.addEventListener('mouseenter', () => toggleMenu(true));
        trigger.parentElement.addEventListener('mouseleave', (e) => {
          // Check if we're not moving to another mega menu
          const relatedTarget = e.relatedTarget;
          if (!relatedTarget || !relatedTarget.closest('[data-megamenu-trigger]')) {
            toggleMenu(false);
          }
        });
        // Keyboard events
        trigger.addEventListener('keydown', handleTriggerKeydown);
        menuLinks.forEach((link, index) => {
          link.addEventListener('keydown', (e) => handleMenuLinkKeydown(e, index));
        });
      }

      secondaryNavCheck(element) {
        this.secondaryNavElement = element;
        this.setNavHeight();
      }
    }
  );
}
